import React from 'react'

const DropContext = React.createContext({
  dropRef: undefined,
})

export default DropContext
